import store from '../../../../../store';
import { ALLOW_EDIT, ALLOW_SIGN } from '../../../setup/Protocol/ProtocolSetup/ProtocolGroupsSetup/permissionType';
import { AE, DV } from '../../shared/Worklist/constants';

export const isLogAvailableForReviewCycle = domainCode => {
  const {
    appInfo: {
      features: { deviationReviewCycleEnabled }
    }
  } = store.getState();

  if (!deviationReviewCycleEnabled && domainCode === DV) {
    return false;
  }
  return [AE, DV].includes(domainCode);
};

export const isLogCanBeLinked = domainCode => {
  const {
    appInfo: {
      features: { deviationReviewCycleEnabled }
    }
  } = store.getState();

  if (!deviationReviewCycleEnabled) {
    return false;
  }
  return [DV].includes(domainCode);
};

export const isCurrentPageIsForLogReviewCycle = currentRouteName => {
  const {
    appInfo: {
      features: { deviationReviewCycleEnabled }
    }
  } = store.getState();

  if (!deviationReviewCycleEnabled && currentRouteName === 'Protocol Deviation Log Review') {
    return false;
  }
  return ['Adverse Event Log Review', 'Protocol Deviation Log Review'].includes(currentRouteName);
};

export const isCurrentPageForLogWithAvailableReviewCycle = currentRouteName => {
  const {
    appInfo: {
      features: { deviationReviewCycleEnabled }
    }
  } = store.getState();

  if (!deviationReviewCycleEnabled && currentRouteName === 'Protocol Deviation Log Row') {
    return false;
  }
  return ['Adverse Event Log Row', 'Protocol Deviation Log Row'].includes(currentRouteName);
};

export const userCanSignOrEdit = currentUserPermissionType => {
  return [ALLOW_SIGN, ALLOW_EDIT].includes(currentUserPermissionType);
};

export const normalizeSubjectIds = data => {
  const limitString = (str, maxLength) => {
    return str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
  };
  return data.reduce((result, el) => {
    result[el.rowId] = limitString(el.subjectIds?.filter(el => !!el)?.join(', '), 50);
    return result;
  }, {});
};

export const isLogWasLinked = (data, rowId) => {
  return data.filter(el => el.rowId === rowId)?.[0]?.subjectIds?.length > 0;
};
